var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-box" }, [
    _c(
      "div",
      { staticClass: "out_box" },
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.isShow ? "祺信-数字债权凭证" : "祺信-数字债权凭证流转单"
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c(
          "a-row",
          {
            staticClass: "top_info",
            attrs: { type: "flex", justify: "space-around" }
          },
          [
            _c("a-col", { attrs: { xxl: 8, xl: 10, lg: 12 } }, [
              _c("p", { staticClass: "c13" }, [
                _c("img", {
                  staticStyle: { "padding-left": "5px" },
                  attrs: {
                    src: require("@/assets/images/logoQX.png"),
                    alt: "",
                    width: "32"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "c63" }, [_vm._v("凭证编号:")]),
                _vm._v(
                  "\n          " + _vm._s(_vm.goldData.gldId) + "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("a-col", { attrs: { xxl: 6, xl: 5, lg: 12 } }, [
              _vm.isShow
                ? _c("p", { staticClass: "c13" }, [
                    _c("span", { staticClass: "c63" }, [_vm._v("开立日期:")]),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.goldData.openTime) +
                        "\n        "
                    )
                  ])
                : _c("p", { staticClass: "c13" }, [
                    _c("span", { staticClass: "c63" }, [_vm._v("流转日期:")]),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.goldData.wanderAboutTime) +
                        "\n        "
                    )
                  ])
            ]),
            _vm._v(" "),
            _c("a-col", { attrs: { xxl: 6, xl: 5, lg: 12 } }, [
              _c("p", { staticClass: "c13" }, [
                _c("span", { staticClass: "c63" }, [_vm._v("到期日期:")]),
                _vm._v(
                  "\n          " + _vm._s(_vm.goldData.exDayStr) + "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("a-col", { attrs: { xxl: 4, xl: 4, lg: 12 } }, [
              _c(
                "p",
                { staticClass: "c13", staticStyle: { "text-align": "right" } },
                [
                  _c("span", { staticClass: "c63" }, [_vm._v("凭证状态:")]),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.goldData.voucherStatus) +
                      "\n        "
                  )
                ]
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _vm.isShow
          ? _c(
              "table",
              {
                staticStyle: { width: "100%", "text-align": "center" },
                attrs: { cellspacing: "0", cellpadding: "0" }
              },
              [
                _c("tbody", [
                  _c("tr", { staticClass: "firstRow" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c63",
                        staticStyle: { width: "15%" },
                        attrs: { valign: "center" }
                      },
                      [_vm._v("全称")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        staticStyle: { width: "25%" },
                        attrs: { valign: "center" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.goldData.estb &&
                                _vm.goldData.estb.customerName
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c63",
                        staticStyle: { width: "15%" },
                        attrs: { valign: "center" }
                      },
                      [_vm._v("全称")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        staticStyle: { width: "25%" },
                        attrs: { valign: "center" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.goldData.rcPty &&
                                _vm.goldData.rcPty.customerName
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("统一社会信用代码")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c13", attrs: { valign: "center" } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.goldData.estb && _vm.goldData.estb.orgCode
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("统一社会信用代码")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c13", attrs: { valign: "center" } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.goldData.rcPty && _vm.goldData.rcPty.orgCode
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("全称")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c13", attrs: { valign: "center" } },
                      [_vm._v(_vm._s(_vm.goldData.guarantorName || "-"))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("开户银行")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c13", attrs: { valign: "center" } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.goldData.rcPty &&
                                _vm.goldData.rcPty.accountName
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("\n            统一社会信用代码\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c13", attrs: { valign: "center" } },
                      [_vm._v(_vm._s(_vm.goldData.guarantorOrgCode || "-"))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("\n            账号\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c13", attrs: { valign: "center" } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.goldData.rcPty && _vm.goldData.rcPty.accountNo
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: " c63",
                        attrs: { valign: "center", rowspan: "2", colspan: "1" }
                      },
                      [_vm._v("\n            凭证信息\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("\n            流转金额\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13 bgStripe",
                        attrs: { valign: "center" }
                      },
                      [
                        _c("span", { staticClass: "c63 amtLeft" }, [
                          _vm._v("\n              人民币（大写）\n            ")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "c13 amtRight" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.goldData.bigGldAmt) +
                              "\n            "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        staticStyle: { padding: "0" },
                        attrs: { valign: "center", rowspan: " 1", colspan: "3" }
                      },
                      [
                        _vm._m(3),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value c13" },
                          _vm._l(_vm.goldData.gldAmountList, function(
                            item,
                            index
                          ) {
                            return _c("p", { key: index, staticClass: "c13" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item) +
                                  "\n              "
                              )
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("\n            能否转让\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: " c13", attrs: { valign: "center" } },
                      [_vm._v("\n            可转让\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("\n            能否融资\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: " c13",
                        attrs: { valign: "center", rowspan: "1", colspan: "2" }
                      },
                      [
                        _vm.goldData.openType == 1
                          ? _c("span", [_vm._v("可融资")])
                          : _c("span", [_vm._v("不可融资")]),
                        _c("br")
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("\n            交易资产包\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: " c13",
                        attrs: { valign: "center", rowspan: "1", colspan: "2" }
                      },
                      [
                        _vm.goldData.openType == 1
                          ? _c("span", [_vm._v("合同/发票等 ")])
                          : _c("span", [_vm._v("-")])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("\n            资产包HASH\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        attrs: { valign: "center", rowspan: "1", colspan: "2" }
                      },
                      [_vm._v("-")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("\n            付款承诺函\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        attrs: { valign: "center", rowspan: " 1", colspan: "2" }
                      },
                      [_vm._v(_vm._s(_vm.goldData.paymentUndertakingNo || "-"))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("\n            承诺函HASH\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        attrs: { valign: "center", rowspan: "1", colspan: "2" }
                      },
                      [_vm._v("-")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("\n            担保协议书\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        attrs: { valign: "center", rowspan: "1", colspan: "2" }
                      },
                      [_vm._v(_vm._s(_vm.goldData.guaranteeNo || "-"))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("\n            协议书HASH\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        attrs: { valign: "center", rowspan: "1", colspan: "2" }
                      },
                      [_vm._v("-")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("\n            开立方承诺信息\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        attrs: { rowspan: "1", colspan: "5" }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "text-align": "left",
                              "padding-left": "15px",
                              "padding-top": "10px"
                            }
                          },
                          [
                            _vm._v(
                              "\n              本凭证所列各项信息真实、无误、合法、合规、有效，债权债务已真实完整发生，对本凭证所列金额承诺到期无条件付款。\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "text-align": "left",
                              float: "right",
                              width: "200px"
                            }
                          },
                          [
                            _vm._v(
                              "\n              签署时间：" +
                                _vm._s(_vm.goldData.openSignTime || "-") +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("\n            接收方承诺信息\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: " c13",
                        attrs: { valign: "center", rowspan: "1", colspan: "5" }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "text-align": "left",
                              "padding-left": "15px",
                              "padding-top": "10px"
                            }
                          },
                          [
                            _vm._v(
                              "\n              我司申明并承诺，对凭证所列债权无重复质押，转让或其他权利在先得情形。\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "text-align": "left",
                              float: "right",
                              width: "200px"
                            }
                          },
                          [
                            _vm._v(
                              "\n              签署时间：" +
                                _vm._s(_vm.goldData.signToacptDay || "-") +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("\n            担保方承诺信息\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: " c13",
                        attrs: { valign: "center", rowspan: "1", colspan: "5" }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "text-align": "left",
                              "padding-left": "15px",
                              "padding-top": "10px"
                            }
                          },
                          [
                            _vm._v(
                              "\n              我司申明并承诺，对开立方未按期执行金额部分承担连带担保责任，并承担付款义务。\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "text-align": "left",
                              float: "right",
                              width: "200px"
                            }
                          },
                          [
                            _vm._v(
                              "签署时间：" +
                                _vm._s(_vm.goldData.guaranteeSignDate || "-")
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: " c63", attrs: { valign: "center" } },
                      [_vm._v("\n            签署栏\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c63",
                        staticStyle: { padding: "0" },
                        attrs: { valign: "center", rowspan: "1", colspan: "5" }
                      },
                      [
                        _c("div", { staticClass: "sign" }, [
                          _c("div", { staticStyle: { width: "33.33%" } }, [
                            _c("p", { staticClass: "signTitle" }, [
                              _vm._v("开立方：")
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _vm._v("\n                  开立经办："),
                                _c(
                                  "span",
                                  {
                                    staticClass: "c13",
                                    staticStyle: { "margin-right": "10px" }
                                  },
                                  [_vm._v(_vm._s(_vm.goldData.openHandle))]
                                ),
                                _vm._v("\n                  复核经办："),
                                _c("span", { staticClass: "c13" }, [
                                  _vm._v(_vm._s(_vm.goldData.openSignUser))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { attrs: { id: "estb" } })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticStyle: { width: "33.33%" } }, [
                            _c("p", { staticClass: "signTitle" }, [
                              _vm._v("担保方：")
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _vm._v("\n                  担保经办："),
                                _c("span", { staticClass: "c13" }, [
                                  _vm._v(
                                    _vm._s(_vm.goldData.guaranteeJingBan || "-")
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.goldData.guaranteeStCd == "2"
                              ? _c("div", { attrs: { id: "danbao" } })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: { width: "33.33%", border: "none" }
                            },
                            [
                              _c("p", { staticClass: "signTitle" }, [
                                _vm._v("接收方：")
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  _vm._v("\n                  接收经办："),
                                  _c("span", { staticClass: "c13" }, [
                                    _vm._v(
                                      _vm._s(_vm.goldData.receiverUser || "-")
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.goldData.gldStCd == "1"
                                ? _c("div", { attrs: { id: "rcPty" } })
                                : _vm._e()
                            ]
                          )
                        ])
                      ]
                    )
                  ])
                ])
              ]
            )
          : _c(
              "table",
              {
                staticStyle: { width: "100%", "text-align": "center" },
                attrs: {
                  cellspacing: "0",
                  cellpadding: "0",
                  "data-sort": "sortDisabled"
                }
              },
              [
                _c("tbody", [
                  _c("tr", { staticClass: "firstRow" }, [
                    _c(
                      "td",
                      {
                        staticClass: "c63",
                        staticStyle: {
                          width: "10%",
                          "word-break": "break-all"
                        },
                        attrs: { valign: "center", rowspan: "2", colspan: "1" }
                      },
                      [_vm._v("\n            兑付方\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c63",
                        staticStyle: { width: "15%" },
                        attrs: { valign: "center" }
                      },
                      [_vm._v("\n            全称\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        staticStyle: { width: "25%" },
                        attrs: { valign: "center" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.goldData.estb &&
                                _vm.goldData.estb.customerName
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c63",
                        staticStyle: {
                          width: "10%",
                          "word-break": "break-all"
                        },
                        attrs: {
                          valign: "center",
                          rowspan: "2",
                          colspan: "1",
                          width: "168"
                        }
                      },
                      [_vm._v("\n            流转方\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c63",
                        staticStyle: {
                          width: "15%",
                          "word-break": "break-all"
                        },
                        attrs: { valign: "center" }
                      },
                      [_vm._v("\n            全称\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        staticStyle: {
                          width: "25%",
                          "word-break": "break-all"
                        },
                        attrs: { valign: "center" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.goldData.pypt &&
                                _vm.goldData.pypt.customerName
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            统一社会信用代码\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c13", attrs: { valign: "center" } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.goldData.estb && _vm.goldData.estb.orgCode
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            统一社会信用代码\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c13", attrs: { valign: "center" } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.goldData.pypt && _vm.goldData.pypt.orgCode
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "c63",
                        attrs: { valign: "center", rowspan: "2", colspan: "1" }
                      },
                      [_vm._v("\n            担保方\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            全称\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c13", attrs: { valign: "center" } },
                      [_vm._v(_vm._s(_vm.goldData.guarantorName || "-"))]
                    ),
                    _vm._v(" "),
                    _vm._m(4),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c13", attrs: { valign: "center" } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.goldData.rcPty &&
                                _vm.goldData.rcPty.customerName
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            统一社会信用代码\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c13", attrs: { valign: "center" } },
                      [_vm._v(_vm._s(_vm.goldData.guarantorOrgCode || "-"))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            统一社会信用代码\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c13", attrs: { valign: "center" } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.goldData.rcPty && _vm.goldData.rcPty.orgCode
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "c63",
                        attrs: { valign: "center", rowspan: "2", colspan: "1" }
                      },
                      [_vm._v("\n            凭证信息\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            流转金额\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13 bgStripe",
                        attrs: { valign: "center" }
                      },
                      [
                        _c("span", { staticClass: "c63 amtLeft" }, [
                          _vm._v("\n              人民币（大写）\n            ")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "c13 amtRight" }, [
                          _vm._v(" " + _vm._s(_vm.goldData.bigGldAmt) + " ")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        staticStyle: { padding: "0" },
                        attrs: { valign: "center", rowspan: " 1", colspan: "3" }
                      },
                      [
                        _vm._m(6),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value c13" },
                          _vm._l(_vm.goldData.gldAmountList, function(
                            item,
                            index
                          ) {
                            return _c(
                              "p",
                              {
                                key: index,
                                class: item == "￥" ? "c63" : "c13"
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item) +
                                    "\n              "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            能否转让\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c13", attrs: { valign: "center" } },
                      [_vm._v("\n            可转让\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            能否融资\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        attrs: { valign: "center", rowspan: "1", colspan: "2" }
                      },
                      [
                        _vm.goldData.openType == 1
                          ? _c("span", [_vm._v("可融资")])
                          : _c("span", [_vm._v("不可融资")]),
                        _c("br")
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            原始凭证信息\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        attrs: { valign: "center", rowspan: "1", colspan: "2" }
                      },
                      [_vm._v(_vm._s(_vm.goldData.originalId))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            凭证HASH\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        attrs: { valign: "center", rowspan: "1", colspan: "2" }
                      },
                      [_vm._v("-")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            交易资产包\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        attrs: { valign: "center", rowspan: " 1", colspan: "2" }
                      },
                      [
                        _vm.goldData.openType == 1
                          ? _c("span", [_vm._v("合同/发票等 ")])
                          : _c("span", [_vm._v("-")])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            资产包HASH\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        attrs: { valign: "center", rowspan: "1", colspan: "2" }
                      },
                      [_vm._v("-")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            转让协议\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        attrs: { valign: "center", rowspan: "1", colspan: "2" }
                      },
                      [_vm._v(_vm._s(_vm.goldData.transferAgreementNo || "-"))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            协议HASH\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        attrs: { valign: "center", rowspan: "1", colspan: "2" }
                      },
                      [_vm._v("-")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            流转方承诺信息\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        attrs: { rowspan: "1", colspan: "5" }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "text-align": "left",
                              "padding-left": "15px",
                              "padding-top": "10px"
                            }
                          },
                          [
                            _vm._v(
                              "\n              本凭证所列各项信息真实、无误、合法、合规、有效，债权债务已真实完整发生。\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "text-align": "left",
                              float: "right",
                              width: "200px"
                            }
                          },
                          [
                            _vm._v(
                              "\n              签署时间：" +
                                _vm._s(
                                  _vm.goldData.wanderAboutSignTime || "-"
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            接收方承诺信息\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c13",
                        attrs: { valign: "center", rowspan: "1", colspan: "5" }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "text-align": "left",
                              "padding-left": "15px",
                              "padding-top": "10px"
                            }
                          },
                          [
                            _vm._v(
                              "\n              我司申明并承诺，对凭证所列债权无重复质押，转让或其他权利在先得情形。\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "text-align": "left",
                              float: "right",
                              width: "200px"
                            }
                          },
                          [
                            _vm._v(
                              "\n              签署时间：" +
                                _vm._s(_vm.goldData.signToacptDay || "-") +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "c63", attrs: { valign: "center" } },
                      [_vm._v("\n            签署栏\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c63",
                        staticStyle: { padding: "0" },
                        attrs: { valign: "center", rowspan: "1", colspan: "5" }
                      },
                      [
                        _c("div", { staticClass: "sign" }, [
                          _c("div", { staticStyle: { width: "50%" } }, [
                            _c("p", { staticClass: "signTitle" }, [
                              _vm._v("流转方：")
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _vm._v("\n                  开立经办："),
                                _c(
                                  "span",
                                  {
                                    staticClass: "c13",
                                    staticStyle: { "margin-right": "10px" }
                                  },
                                  [_vm._v(_vm._s(_vm.goldData.wanderAboutUser))]
                                ),
                                _vm._v("\n                  复核经办："),
                                _c("span", { staticClass: "c13" }, [
                                  _vm._v(
                                    _vm._s(_vm.goldData.wanderAboutCheckUser)
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { attrs: { id: "pypt" } })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { width: "50%", border: "none" } },
                            [
                              _c("p", { staticClass: "signTitle" }, [
                                _vm._v("接收方：")
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  _vm._v("\n                  接收经办："),
                                  _c("span", { staticClass: "c13" }, [
                                    _vm._v(
                                      _vm._s(_vm.goldData.receiverUser || "-")
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.goldData.gldStCd == "1"
                                ? _c("div", { attrs: { id: "rcPty" } })
                                : _vm._e()
                            ]
                          )
                        ])
                      ]
                    )
                  ])
                ])
              ]
            ),
        _vm._v(" "),
        _c("div", { staticClass: "footer" }, [
          _c("div", { staticClass: "item" }, [
            _c("span", [_vm._v("区块链存证证书二维码")]),
            _vm._v(" "),
            _c("img", {
              staticClass: "img",
              attrs: { height: "80", width: "80", src: _vm.certificateURL }
            })
          ]),
          _vm._v(" "),
          _vm._m(7),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c("span", [_vm._v("数字债权凭证二维码")]),
            _vm._v(" "),
            _c("img", {
              staticClass: "img",
              attrs: { height: "80", width: "80", src: _vm.voucherURL }
            })
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticClass: "c63",
        staticStyle: { width: "10%" },
        attrs: { valign: "center", rowspan: "2", colspan: "1" }
      },
      [
        _vm._v("\n            开立方\n            "),
        _c("br"),
        _vm._v("\n            （债务人）\n          ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticClass: "c63",
        staticStyle: { width: "10%" },
        attrs: { valign: "center", rowspan: "4", colspan: "1" }
      },
      [
        _vm._v("\n            接收方\n            "),
        _c("br"),
        _vm._v("\n            （债权人）\n          ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticClass: " c63",
        attrs: { valign: "center", rowspan: "2", colspan: "1" }
      },
      [
        _vm._v("\n            担保方\n            "),
        _c("br"),
        _vm._v("\n            （担保人）\n          ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "key c63" }, [
      _c("p", [_vm._v("亿")]),
      _vm._v(" "),
      _c("p", [_vm._v("千万")]),
      _vm._v(" "),
      _c("p", [_vm._v("百万")]),
      _vm._v(" "),
      _c("p", [_vm._v("十万")]),
      _vm._v(" "),
      _c("p", [_vm._v("万")]),
      _vm._v(" "),
      _c("p", [_vm._v("千")]),
      _vm._v(" "),
      _c("p", [_vm._v("百")]),
      _vm._v(" "),
      _c("p", [_vm._v("十")]),
      _vm._v(" "),
      _c("p", [_vm._v("元")]),
      _vm._v(" "),
      _c("p", [_vm._v("角")]),
      _vm._v(" "),
      _c("p", [_vm._v("分")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: { width: "10%", "word-break": "break-all" },
        attrs: {
          colspan: "1",
          valign: "center",
          align: "null",
          width: "168",
          rowspan: "2"
        }
      },
      [_vm._v("\n            接收方"), _c("br")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "c63", attrs: { valign: "center" } }, [
      _vm._v("\n            全称"),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "key c63" }, [
      _c("p", [_vm._v("亿")]),
      _vm._v(" "),
      _c("p", [_vm._v("千万")]),
      _vm._v(" "),
      _c("p", [_vm._v("百万")]),
      _vm._v(" "),
      _c("p", [_vm._v("十万")]),
      _vm._v(" "),
      _c("p", [_vm._v("万")]),
      _vm._v(" "),
      _c("p", [_vm._v("千")]),
      _vm._v(" "),
      _c("p", [_vm._v("百")]),
      _vm._v(" "),
      _c("p", [_vm._v("十")]),
      _vm._v(" "),
      _c("p", [_vm._v("元")]),
      _vm._v(" "),
      _c("p", [_vm._v("角")]),
      _vm._v(" "),
      _c("p", [_vm._v("分")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("span", [_vm._v("电子签名证书颁发机构")]),
      _vm._v(" "),
      _c("img", {
        staticClass: "img",
        attrs: { height: "60", src: require("@/assets/images/cfca.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4616af49", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4616af49","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gold-details-basic/index.vue
// module id = RkNn
// module chunks = 1